import { render } from "./OrdersQuestion.vue?vue&type=template&id=0f3b4905"
import script from "./OrdersQuestion.vue?vue&type=script&lang=js"
export * from "./OrdersQuestion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__